export default __webpack_public_path__ + "static/media/photo_carole_face.4c4f5bcb.JPG";